<script setup lang="ts">
import type { DateRangePickerFieldValue } from '@/components/pickerFields/DateRangePickerField.vue';

import { reactive, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import CustomerCodeAutocompleteField from '@/components/fields/CustomerCodeAutocompleteField.vue';
import KTextField from '@/components/fields/KTextField.vue';
import DateRangePickerField from '@/components/pickerFields/DateRangePickerField.vue';
import useForm from '@/composables/useForm';

export type BookedJobsView = 'user' | 'customer';

export interface InitialData {
  dates?: DateRangePickerFieldValue | null;
  user?: string | null;
  customer?: string | null;
}

export interface ValidData {
  dates: DateRangePickerFieldValue;
  user?: string | null;
  customer?: string | null;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  isStaff?: boolean;
  view?: BookedJobsView;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  isStaff: false,
  view: 'user',
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    :class="$style.bookedJobsSearchForm"
    data-testid="bookedJobsSearchForm"
    @submit.prevent="handleSubmit"
  >
    <DateRangePickerField
      v-model="formData.dates"
      size="lg"
      label="Date range"
      :disabled="props.loading"
      :class="$style.field"
      @update:model-value="() => handleSubmit()"
    />
    <template v-if="props.isStaff">
      <KTextField
        v-if="props.view === 'user'"
        v-model="formData.user"
        size="lg"
        label="User name"
        :disabled="props.loading"
        :class="$style.field"
      />
      <CustomerCodeAutocompleteField
        v-else
        v-model="formData.customer"
        size="large"
        :disabled="props.loading"
        :class="$style.field"
      />
      <KBtn
        type="submit"
        size="lg"
        prepend-icon="mdi-magnify"
        :loading="props.loading"
        :class="$style.submit"
      >
        Search
      </KBtn>
    </template>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.bookedJobsSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
